import React from "react";
import { defineMessages } from "react-intl";
import { showAuthorized } from "assets/scripts/components/containers/public/Registration/registrationUtils";
import CheckboxFormGroup from "assets/scripts/components/common/form/CheckboxFormGroup/CheckboxFormGroup";
import { REQUIRED } from "assets/scripts/constants/FormMessages";
const messages = defineMessages({
    authorizedLabel: {
        id: "forms.accountValidation.authorized.label",
        defaultMessage: "I am the person, or I am representing the person who is authorized to act on behalf of the estate."
    }
});
export function getErrors(value, deceased) {
    return {
        authorized: showAuthorized(deceased) && !value.authorized ? REQUIRED : null
    };
}
export default function AuthorizedInput(props) {
    if (!showAuthorized(props.deceased)) {
        return null;
    }
    return (<CheckboxFormGroup name="authorized" label={messages.authorizedLabel} value={props.value.authorized} onChange={authorized => props.onChange({ authorized })} error={props.errors.authorized} backendError={props.backendErrors.attestation} required/>);
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/public/AuthorizedInput/AuthorizedInput.tsx